import script from "./CrudCategoriasActivo.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudCategoriasActivo.vue?vue&type=script&setup=true&lang=js"

import "./CrudCategoriasActivo.vue?vue&type=style&index=0&id=ff1576e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1576e0"]])

export default __exports__